// extracted by mini-css-extract-plugin
module.exports = {"chestImageWrapper":"_r5MzeMR","defaultChestImage":"_2qJxB4k","multiChestImage":"_mD2zGmd"};